export enum Prefixes {
  ADVISORY_BOARD_ID = 'advisory-', // Advisory Board 'Team' member
  BLOGPOST_ID = 'blogpost-',
  NEWSCARD_ID = 'newscard-', // Card in the newsletter carousel
  PARTNER_ID = 'partner-', // Partner ( = institution) prefix
  PUBLICATION_ID = 'publication-',
  REPORT_ID = 'report-', // Report prefix
  POLICY_ID = 'policy-', // Policy prefix
  NEWS_ID = 'newsletter-', // Report prefix
  RESEARCH_ID = 'research-', // Research ( = publication) prefix
  RESEARCHER_ID = 'researcher-', // Researcher Team Member prefix
  REBOOTER_ID = 'rebooter-', // Vienna Reboot Team Member (= "Rebooters") prefix
  COORDINATOR_ID = 'coordinator-', // Vienna Reboot Team Member (= "Rebooters") prefix
  TEAM_ID = 'team-', // Researcher Team prefix
  EXTERNAL_ID = 'external-', // People that do not belong to any team or organisation
  HOME_MODAL_ID = "homemodal-", // For content in Home page that is displayed inside a Modal.
  WORK_PACKAGE_MODAL_ID = "workpackage-", // For content in Home page that is displayed inside a Modal.
}
